export default __webpack_public_path__ + "static/media/bulkRemoveMeter.40ae8a4b.svg";